module.exports = __webpack_public_path__ + "media/images/recruitment/landing/client02-d3a4ea789c2247d839073b72b5ccbb64.png";